import { DateFormat } from '@app/utils/helpers';
import { DatePicker as AntDatePicker, type DatePickerProps } from 'antd';

export const DatePicker = ({ ...props }: DatePickerProps) => {
  return <AntDatePicker size="large" format={DateFormat.Date} {...props} />;
};
